export class PostoCombutivel {
  id!: number;
  nome!: string;
  email!: string;
  cidadeDetino!: string;
}
